import { Injectable, inject, signal } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { ProcessRunnerNotificationApiHubService } from "@api-hubs/process-runner-notification.api.hub.service";
import { ApiProcess } from "@api/apiProcesses";
import { NotificationMessage } from "@api/model/notificationMessage";
import { ProcessRunnerNotificationMessage } from "@api/model/processRunnerNotificationMessage";
import { UserService } from "@core/client/user.service";
import { userVisibleProcesses } from "@process-runner/processes.model";
import { ProcessesService } from "@process-runner/processes.service";
import { VoltaToastrService } from "@shared/services/volta-toastr/volta-toastr.service";

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {

    processRunnerNotificationApiHubService = inject(ProcessRunnerNotificationApiHubService);
    userService = inject(UserService);
    toastrService = inject(VoltaToastrService);
    processesService = inject(ProcessesService);

    constructor(){

        this.setupNotifications();

        this.userService.user$.subscribe({
            next: (value) => {
                if(value){
                    console.log("[NotificationsService] User Changed, starting notification subscription")
                    this.subscribe();
                }
                else{
                    console.log("[NotificationsService] User Left")
                    this.unsubscribe();
                }
            }
        })
        
    }

    setupNotifications(){
        this.processRunnerNotificationApiHubService.Hub.ReceiveNotification((data:NotificationMessage) => {

            console.log("[NotificationsService] Received ReceiveNotification");
            this.handleNotification(data);

        })
    }

    subscribe(){
        this.processRunnerNotificationApiHubService.Connection.start()
        .then(() => {
            console.log("[NotificationsService] Connection Start");
        })
        .catch((error) => {
            console.log("[NotificationsService] Error");
        })
    }

    unsubscribe(){
        this.processRunnerNotificationApiHubService.Connection.stop()
        .then(() => {
            console.log("[NotificationsService] Connection Stopped");
        })
        .catch((error) => {
            console.log("[NotificationsService] Error");
        })
    }

    handleNotification(data:NotificationMessage){

        switch(data.notificationTypeIdentifier){
            case 'ProcessRunnerJob':
                this.addProcessNotification(data.metaData);
                break;
            default:
                //TODO: Needs to be worked on.
                this.toastrService.show(data.message);
                break;
        }

    }

    //#region Process Runner Notifications
    private _processNotifications = signal<ProcessRunnerNotificationMessage[]>([]);
    processNotifications$ = toObservable<ProcessRunnerNotificationMessage[]>(this._processNotifications);
    processNotifications = this._processNotifications.asReadonly();

    addProcessNotification(data:ProcessRunnerNotificationMessage){

        const existingIndex = this._processNotifications().findIndex((process) => 
            process.executionDetails.executionId == data.executionDetails.executionId
            && process.executionDetails.executionId != 0
        );
        const emptyPresetIndex = this._processNotifications().findIndex((process) => 
            process.executionDetails.processName == data.executionDetails.processName 
            && process.executionDetails.tenantId == data.executionDetails.tenantId
            && process.executionDetails.executionId == 0
        )

        //If Process is already listed, update it
        if(existingIndex != -1){
            this._processNotifications.update((processes) => {
                processes[existingIndex] = data;
                return [...processes];
            })
        }
        //If an empty preset exists, take over
        else if(emptyPresetIndex != -1){
            this._processNotifications.update((processes) => {
                processes[emptyPresetIndex] = data;
                return [...processes];
            })
        }
        //If not, add it with the list
        else{
            if(userVisibleProcesses.includes(data.executionDetails.processName as ApiProcess)){
                this._processNotifications.update((processes) => [...processes, data]);
            }
        }
    }

    removeProcessNotification(executionId:number){
        this._processNotifications.update((processes) => [...processes.filter((process) => process.executionDetails.executionId != executionId)]);
    }
    //#endregion

    //#region Reporting Notifications
    
    //#endregion
}
